import { Alert, Flex, Spin } from 'antd';
import { useTranslation } from 'translations/hooks';

import { RingComplianceStatus } from 'business/quality-control/pages/ring-compliance-report/hooks/data/types';
import { useGetRingValidationDetail } from 'business/quality-control/pages/ring-compliance-report-detail/hooks/use-get-detail';

import { RingComplianceBody } from './ring-compliance-body';
import { RingComplianceHeader } from './ring-compliance-header';
import { RingPicturesAnnex } from './ring-pictures-annex';

export const RingComplianceDetailContainer = ({
  ringId,
}: {
  ringId: string;
}) => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useGetRingValidationDetail(ringId);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" style={{ padding: '40px 0' }}>
        <Spin tip={t('common.loading')}>
          <div style={{ minHeight: 60, minWidth: 60 }} />
        </Spin>
      </Flex>
    );
  }

  if (error) {
    return <Alert message={t('errors.error_generic')} type="error" />;
  }

  if (!data) {
    return null;
  }

  const ringSegments = [...data.segments]
    .map((segment) => ({ label: segment.segmentType }))
    .sort((first, second) => first.label.localeCompare(second.label));

  const isReportReady = [
    RingComplianceStatus.Compliant,
    RingComplianceStatus.Approved,
    RingComplianceStatus.Refused,
  ].includes(data.status as RingComplianceStatus);

  return (
    <Flex vertical gap={12}>
      <RingComplianceHeader detail={data} ringSegments={ringSegments} />
      <RingComplianceBody detail={data} />
      {isReportReady && <RingPicturesAnnex ringId={data.id} />}
    </Flex>
  );
};
